declare global {
  interface Fbq {
    (...args: any[]): void;
    callMethod?: (...args: any[]) => void;
    queue?: any[];
    loaded?: boolean;
    version?: string;
    push?: (...args: any[]) => void;
  }

  interface Window {
    PaymentFormSdk: any;
    fbq: Fbq;
  }
}

export enum AbTestValues {
  DEFAULT = 'default',
  TEST = 'test',
  CONTROL = 'control',
}

export enum ProjectType {
  APP = 'app',
  FUNNELS = 'funnels',
}
